/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, May 17th 2026, 10:48:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import ListItemText from "@mui/material/ListItemText";
import { Activity as ActivityIcon } from "react-feather";

import { APISERVICEPATHS } from "lib/api";
import { ProcessDefinition } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";
import {
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
  APIMany2OneSelectFormInput,
  ConcreteAPIMany2OneSelectFormInputProps,
} from "ui-widgets";

interface ProcessDefinitionMany2ManyPickerProps<TPrimaryObject>
  extends ConcreteAPIMany2ManyTransferListFormInputProps<TPrimaryObject, ProcessDefinition> {
  apiQueryParams?: { key: string };
}

export const ProcessDefinitionTransferListInput = <TPrimaryObject,>(
  props: ProcessDefinitionMany2ManyPickerProps<TPrimaryObject>
) => {
  return (
    <APIMany2ManyTransferListFormInput<TPrimaryObject, ProcessDefinition>
      apiServicePath={APISERVICEPATHS.processDefinitions}
      itemIdProperty="id"
      getOptionLabel={(option) => <ListItemText primary={option.title} />}
      getSearchableName={(option) => `${option.title} ${option.service_code}`}
      noDataMessage="No process templates found."
      {...props}
    />
  );
};

interface ProcessDefinitionMany2OnePickerProps<TPrimaryObject>
  extends ConcreteAPIMany2OneSelectFormInputProps<TPrimaryObject, ProcessDefinition> {}

export const ProcessDefinitionMany2OnePicker = <TPrimaryObject,>(
  props: ProcessDefinitionMany2OnePickerProps<TPrimaryObject>
) => {
  return (
    <APIMany2OneSelectFormInput<TPrimaryObject, ProcessDefinition>
      label={props.label ?? "Process Definition"}
      itemIdProperty="id"
      getOptionLabel={(option) => option.title}
      loadingText="Loading Process Definitions"
      apiServicePath={APISERVICEPATHS.processDefinitions}
      inputStartAdornment={<ActivityIcon color={COLORSCHEME.primary} />}
      {...props}
    />
  );
};
